import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
import { compose } from 'redux';

import { selectActiveVenueId } from 'selectors/general';
import { asFormSubmit } from 'components/Form';
import { selectInstructors, selectInstructorsIsLoading } from 'features/Instructors';

import EditScheduleForm from './EditScheduleForm';
import {
  selectSchedulesClasses,
  selectCreatedClassId,
  selectCreatedInstructorId,
  selectSchedulesClassesIsLoading,
  selectSchedule,
  selectScheduleIsLoading,
} from '../../Schedules.selectors';
import { updateSchedule as updateScheduleAction, deleteSchedule as deleteScheduleAction } from '../../Schedules.saga';
import { DRAFT_STATUS, PUBLISHED_STATUS } from '../../Schedules.helpers';
import { isRecurringSchedule, getNextSingleDayExceptionDate } from '../ScheduleForm.helpers';
import { editScheduleSyncValidation as validate } from '../ScheduleForm.validator';

export const EDIT_SCHEDULE_FORM_NAME = 'SCHEDULES/EDIT_SCHEDULE_FORM';

const getFormInitialValues = (state, schedule) => {
  const createdClassId = selectCreatedClassId(state);
  const createdInstructorId = selectCreatedInstructorId(state);
  const { classId, instructorId } = schedule;

  return {
    ...schedule,
    classId: createdClassId || classId,
    instructorId: createdInstructorId || instructorId,
  };
};

const mapStateToProps = state => {
  const isScheduleLoading = selectScheduleIsLoading(state);
  const schedule = selectSchedule(state);
  const { status, classTitle, id: scheduleId, startTime, lastChange } = schedule;
  const venueId = selectActiveVenueId(state);
  const classes = selectSchedulesClasses(state, venueId);
  const instructors = selectInstructors(state, venueId);
  const isLoading =
    selectSchedulesClassesIsLoading(state, venueId) || selectInstructorsIsLoading(state, venueId) || isScheduleLoading;
  const formValues = getFormValues(EDIT_SCHEDULE_FORM_NAME)(state) || {};
  const { scheduleType, isNoEndDate } = formValues;
  const isRecurring = isRecurringSchedule(scheduleType);
  const nextSingleDayExceptionDate = getNextSingleDayExceptionDate(formValues);

  return {
    classes,
    classTitle,
    initialStartTime: startTime,
    initialValues: getFormInitialValues(state, schedule),
    instructors,
    isLoading,
    isNoEndDate,
    isPublished: status === PUBLISHED_STATUS,
    isRecurring,
    nextSingleDayExceptionDate,
    scheduleId,
    status,
    lastChange,
  };
};

const mapDispatchToProps = {
  updateSchedule: updateScheduleAction,
  deleteSchedule: deleteScheduleAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { status, scheduleId } = stateProps;
  const { updateSchedule, deleteSchedule } = dispatchProps;
  const shouldShowModalOnPublish = status !== PUBLISHED_STATUS;

  return {
    saveAsDraft: asFormSubmit((values, asyncSubmitFns) =>
      updateSchedule({ ...values, status: DRAFT_STATUS }, null, asyncSubmitFns)
    ),
    saveAsPublished: asFormSubmit((values, asyncSubmitFns) =>
      updateSchedule({ ...values, status: PUBLISHED_STATUS }, shouldShowModalOnPublish, asyncSubmitFns)
    ),
    deleteSchedule: deleteSchedule.bind(null, scheduleId),
    ...stateProps,
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  reduxForm({ form: EDIT_SCHEDULE_FORM_NAME, validate, enableReinitialize: true })
)(EditScheduleForm);
